interface Props {
    img: string;
    title: string;
    paragraph?: string;
}
export default function NoResultsFound({ img, title, paragraph }: Props) {
    return (
        <div className="no-result">
            <img src={img} alt="no-results" />
            <div className="no-result__content">
                <h1 className="no-result__content--title">{title}</h1>
                {paragraph && <p className="no-result__content--paragraph">{paragraph}</p>}
            </div>
        </div>
    );
}
